import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { intlMessage, reduxFormPropTypes } from 'constants/propTypes';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import RenderTextField from 'components/RenderTextField';
import LINKS from 'constants/links';
import { bem } from 'helpers/class-name';
import messages from './EmailModal.messages';
import './EmailModal.scss';

const { block, element } = bem('email-modal');

const EmailModal = ({
  acceptDisabled,
  acceptMessage = messages.sendEmail,
  acceptWaiting,
  banner,
  cancelMessage = messages.cancel,
  handleSubmit,
  dirty,
  valid,
  submitting,
  subject,
  title,
  to,
  ...rest
}) => (
  <Confirm
    className={block()}
    onConfirm={handleSubmit}
    title={title}
    cancelNode={<Message message={cancelMessage} />}
    acceptNode={<Message message={acceptMessage} />}
    acceptDisabled={!dirty || !valid || submitting}
    acceptWaiting={submitting}
    {...rest}>
    {banner && <div className={element('section')}>{banner}</div>}
    <div className={element('section')}>
      <Message className={element('label')} as="div" message={messages.toLabel} />
      <span className={element('text')}>{to}</span>
    </div>
    <div className={element('section')}>
      <Message className={element('label')} as="div" message={messages.subjectLabel} />
      <span className={element('text')}>{subject}</span>
    </div>
    <div className={element('section')}>
      <Message className={element('label')} as="label" message={messages.messageLabel} />
      <Field name="message" className={element('message-input')} component={RenderTextField} />
      <Message
        className={element('label')}
        message={messages.legalNotice}
        values={{
          a: text => (
            <a href={LINKS.userMessagingUsageGuidelines.href} target="_blank" rel="noopener noreferrer">
              {text}
            </a>
          ),
        }}
      />
    </div>
  </Confirm>
);

EmailModal.propTypes = {
  acceptMessage: intlMessage,
  cancelMessage: intlMessage,
  banner: PropTypes.node,
  subject: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  to: PropTypes.node.isRequired,
  ...reduxFormPropTypes.form,
};

export default EmailModal;
